/**
 * The end-of-life pages' paths — `docs/adr/7003`, `7004`, `7005`. Their own module, apart from
 * `scope.ts`, so a page that only LINKS here (Consolidation ▸ Lanes) does not read this family's
 * URL parameters: the URL-parameter census (ADR 9054) counts the keys a screen's code reaches.
 */

/** The transitions page, the evidence pages under it, and the withdrawals page. */
export const TRANSITIONS_PATH = '/exit/lifecycle';
export const WITHDRAWALS_PATH = '/exit/lifecycle-withdrawals';
export const OUTLET_PATH = '/exit/lifecycle-outlet';
export const OUTLET_TRANSFERS_PATH = '/exit/lifecycle-outlet-transfers';
/** The phase register and one article's history under it (`docs/adr/7005`). */
export const PHASES_PATH = '/exit/lifecycle-phases';
